var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.824.75v11.613H.75V8.969a2.406 2.406 0 0 0 1.648-.707c.437-.437.707-1.04.707-1.706 0-.665-.27-1.268-.707-1.705A2.406 2.406 0 0 0 .75 4.144V.75h5.074zM21.25.75v3.394a2.406 2.406 0 0 0-1.648.707 2.406 2.406 0 0 0-.707 1.705c0 .666.27 1.269.707 1.706a2.406 2.406 0 0 0 1.648.707v3.394H8.708V.75H21.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplains);
export default __webpack_public_path__ + "static/media/complains.53f95e5eb14b6b82ea4b6c054cb5ee48.svg";
export { ForwardRef as ReactComponent };